// extracted by mini-css-extract-plugin
export var aiStarIcon = "_bi-4";
export var closeButton = "_bi-6";
export var dismissButton = "_bi-3";
export var editImageWithAiContainer = "_bi-8";
export var imageUploadWrapper = "_bi-7";
export var misspelledWord = "_bi-5";
export var spellCheckContainer = "_bi-2";
export var spin = "_bi-1";
export var spinning = "_bi-0";